import { Routes } from '@angular/router';

export const routes: Routes = [
  { path: '', redirectTo: 'menu', pathMatch: 'full' },
  { path: 'menu',     loadComponent: () => import('./features/main-menu/main-menu').then(m => m.MainMenu) },
  { path: 'scenario', loadComponent: () => import('./features/scenario-select/scenario-select').then(m => m.ScenarioSelect) },
  { path: 'game',     loadComponent: () => import('./features/adventure-map/adventure-map').then(m => m.AdventureMap) },
  { path: 'combat',   loadComponent: () => import('./features/combat/combat').then(m => m.Combat) },
  { path: 'town',     loadComponent: () => import('./features/town/town').then(m => m.Town) },
  { path: 'hero',     loadComponent: () => import('./features/hero-screen/hero-screen').then(m => m.HeroScreen) },
  { path: '**',       redirectTo: 'menu' },
];
